'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp2;

// import { InfoBar } from 'components';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _reactRouterBootstrap = require('react-router-bootstrap');

var _Navbar = require('react-bootstrap/lib/Navbar');

var _Navbar2 = _interopRequireDefault(_Navbar);

var _Nav = require('react-bootstrap/lib/Nav');

var _Nav2 = _interopRequireDefault(_Nav);

var _NavItem = require('react-bootstrap/lib/NavItem');

var _NavItem2 = _interopRequireDefault(_NavItem);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _auth = require('redux/modules/auth');

var _userCredential = require('redux/modules/userCredential');

var _reactRouterRedux = require('react-router-redux');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _reduxConnect = require('redux-connect');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 33e0ff default active color
var App = (_dec = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    var promises = [];
    if (!(0, _auth.isLoaded)(getState())) {
      promises.push(dispatch((0, _auth.load)()));
    }
    return _promise2.default.all(promises).then(function () {
      if (!(0, _userCredential.isLoaded)(getState())) {
        var userId = getState().auth.user.userId;
        promises.push(dispatch((0, _userCredential.load)(userId)));
      }
    });
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user, userIsAdmin: state.userCredential };
}, { logout: _auth.logout, pushState: _reactRouterRedux.push }), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(App, _Component);

  function App() {
    var _ref2;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, App);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = App.__proto__ || (0, _getPrototypeOf2.default)(App)).call.apply(_ref2, [this].concat(args))), _this), _this.handleLogout = function (event) {
      event.preventDefault();
      _this.props.logout();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(App, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.user && nextProps.user) {
        // login
        this.props.pushState('/profile');
        // somehow this will set this.props.user?
      } else if (this.props.user && !nextProps.user) {
        // logout
        this.props.pushState('/');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var user = this.props.user;

      var styles = require('./App.scss');
      console.log(this.props.userIsAdmin);

      return _react2.default.createElement(
        'div',
        { className: styles.app },
        _react2.default.createElement(_reactHelmet2.default, _config2.default.app.head),
        _react2.default.createElement(
          _Navbar2.default,
          { fixedTop: true },
          _react2.default.createElement(
            _Navbar2.default.Header,
            null,
            _react2.default.createElement(
              _Navbar2.default.Brand,
              null,
              _react2.default.createElement(
                _reactRouter.IndexLink,
                { to: '/', activeStyle: { color: '#ff9933' } },
                _react2.default.createElement('div', { className: styles.brand })
              )
            ),
            _react2.default.createElement(_Navbar2.default.Toggle, null)
          ),
          _react2.default.createElement(
            _Navbar2.default.Collapse,
            null,
            _react2.default.createElement(
              _Nav2.default,
              { navbar: true, pullRight: true },
              user && _react2.default.createElement(
                _reactRouterBootstrap.LinkContainer,
                { to: '/profile' },
                _react2.default.createElement(
                  _NavItem2.default,
                  { eventKey: 1 },
                  'Profile'
                )
              ),
              user && _react2.default.createElement(
                _reactRouterBootstrap.LinkContainer,
                { to: '/moduleslanding' },
                _react2.default.createElement(
                  _NavItem2.default,
                  { eventKey: 2 },
                  'Modules'
                )
              ),
              user && _react2.default.createElement(
                _reactRouterBootstrap.LinkContainer,
                { to: '/resourceslanding' },
                _react2.default.createElement(
                  _NavItem2.default,
                  { eventKey: 3 },
                  'Resources'
                )
              ),
              user && _react2.default.createElement(
                _reactRouterBootstrap.LinkContainer,
                { to: '/recipeslanding' },
                _react2.default.createElement(
                  _NavItem2.default,
                  { eventKey: 4 },
                  'Recipes'
                )
              ),
              user && this.props.userIsAdmin.isAdmin && _react2.default.createElement(
                _reactRouterBootstrap.LinkContainer,
                { to: '/admin' },
                _react2.default.createElement(
                  _NavItem2.default,
                  { eventKey: 5 },
                  'Admin'
                )
              ),
              _react2.default.createElement(
                _reactRouterBootstrap.LinkContainer,
                { to: '/about' },
                _react2.default.createElement(
                  _NavItem2.default,
                  { eventKey: 6 },
                  'About Us'
                )
              ),
              !user && _react2.default.createElement(
                _reactRouterBootstrap.LinkContainer,
                { to: '/login' },
                _react2.default.createElement(
                  _NavItem2.default,
                  { eventKey: 7 },
                  'Login'
                )
              ),
              user && _react2.default.createElement(
                _reactRouterBootstrap.LinkContainer,
                { to: '/logout' },
                _react2.default.createElement(
                  _NavItem2.default,
                  { eventKey: 8, className: 'logout-link', onClick: this.handleLogout },
                  'Logout'
                )
              )
            ),
            user && _react2.default.createElement(
              'p',
              { className: styles.loggedInMessage + ' navbar-text' },
              'Logged in as ',
              _react2.default.createElement(
                'strong',
                null,
                user.username
              ),
              '.'
            ),
            !user && _react2.default.createElement('p', { className: styles.loggedInMessage + ' navbar-text' }),
            _react2.default.createElement('div', { style: { 'margin-top': '2px' }, id: 'google_translate_element' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.appContent },
          this.props.children
        )
      );
    }
  }]);
  return App;
}(_react.Component), _class2.propTypes = {
  children: _propTypes2.default.object.isRequired,
  user: _propTypes2.default.object,
  logout: _propTypes2.default.func.isRequired,
  pushState: _propTypes2.default.func.isRequired,
  loginError: _propTypes2.default.string,
  userIsAdmin: _propTypes2.default.object
}, _class2.contextTypes = {
  store: _propTypes2.default.object.isRequired
}, _temp2)) || _class) || _class);
exports.default = App;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/App.js
// module id = 1271
// module chunks = 0